import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acf3eaf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { justify: "space-between" }
const _hoisted_2 = { class: "flex flex-wrap" }
const _hoisted_3 = { class: "flex-item ml-2" }
const _hoisted_4 = {
  class: "mt-3",
  align: "start"
}
const _hoisted_5 = { class: "flex-item ml-2" }
const _hoisted_6 = {
  class: "mt-3",
  align: "start"
}
const _hoisted_7 = {
  class: "text-subtitle-2",
  style: {"color":"gray"}
}

import { useI18n } from "vue-i18n"
import { computed, ref, watch } from "vue"
import { Doctor, Hospital } from "@/types"
import { onMounted } from "vue"
import moment from "moment"
import GeneralInformation from "@/components/StudentProfile/GeneralInformation/GeneralInformation.vue"
import { useUserActions } from "@/stores/user-actions"

export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalApply',
  props: {
    hospital: {}
  },
  setup(__props: any) {

const { t } = useI18n()

const props = __props
const hospital = ref<Hospital | undefined>(props.hospital)
const startDate = ref<Date | null>(null)
const endDate = ref<Date | null>(null)
const today = ref(new Date())
const isNewDateLoading = ref(false)
const userAction = useUserActions()
const isHospitalAvailable = ref(false)
const availableDocs = ref<Doctor[]>()
const selectedDoctor = ref<Doctor>()
onMounted(async () => {
  await getParams()
  await handleStartDateChange(startDate.value)
})

const getParams = async () => {
  const storedSearchParams = localStorage.getItem("searchParams")
  if (storedSearchParams) {
    const savedSearchParams = JSON.parse(storedSearchParams)
    startDate.value = savedSearchParams?.startDate
      ? moment(savedSearchParams?.startDate).locale("de").toDate()
      : null

    endDate.value = savedSearchParams?.endDate
      ? moment(savedSearchParams?.endDate).locale("de").toDate()
      : null
  }
}

async function handleStartDateChange(newDate: Date | null): Promise<void> {
  isNewDateLoading.value = true

  if (newDate) {
    startDate.value = newDate
    endDate.value = new Date(startDate.value)
    endDate.value.setDate(endDate.value.getDate() + 30)
    const response = await userAction.isHospitalAvailable(
      hospital.value?._id ?? "",
      userAction.getDatesInString(startDate.value),
      userAction.getDatesInString(endDate.value)
    )
    availableDocs.value = response.result?.docs as Doctor[]
    isHospitalAvailable.value = availableDocs.value.length > 0
  }
  isNewDateLoading.value = false
}

const doctorName = (d: Doctor): string => {
  return d?.title + " " + d?.firstName + " " + d?.lastName
}

const doctorValue = (d: Doctor): Doctor => {
  return d
}

watch(startDate, handleStartDateChange)

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("you-apply")), 1),
          _createVNode(_component_VueDatePicker, {
            class: "mb-2",
            "enable-time-picker": false,
            modelValue: startDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
            format: "dd MMM yyyy",
            density: "compact",
            variant: "outlined",
            clearable: false,
            label: _ctx.$t('you-apply'),
            "min-date": today.value,
            onChange: handleStartDateChange,
            placeholder: _ctx.$t('search.date-line')
          }, null, 8, ["modelValue", "label", "min-date", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t("choose-doctor")) + " ", 1),
            _createElementVNode("span", _hoisted_7, "( " + _toDisplayString(_ctx.$t("not-necessary")) + " )", 1)
          ]),
          _createVNode(_component_v_autocomplete, {
            modelValue: selectedDoctor.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDoctor).value = $event)),
            density: "compact",
            placeholder: _ctx.$t('doctor.doctor'),
            items: availableDocs.value,
            "item-title": doctorName,
            "item-value": doctorValue,
            variant: "outlined"
          }, {
            item: _withCtx(({ props, item }) => [
              _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                subtitle: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.raw.department), 1)
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "items"])
        ])
      ]),
      (isNewDateLoading.value)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            color: "green",
            indeterminate: ""
          }))
        : _createCommentVNode("", true),
      (!isHospitalAvailable.value && startDate.value !== null && !isNewDateLoading.value)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            class: "ml-6 mr-6",
            color: "#C51162",
            icon: "mdi-cancel",
            theme: "dark",
            border: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("no-availability")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(GeneralInformation, {
      isApplying: true,
      isHospitalApplying: true,
      isDoctorAvailable: isHospitalAvailable.value,
      hospitalId: hospital.value?._id,
      doctorId: selectedDoctor.value?._id,
      startDate: startDate.value,
      endDate: endDate.value,
      hasAlreadyApplied: false
    }, null, 8, ["isDoctorAvailable", "hospitalId", "doctorId", "startDate", "endDate"])
  ], 64))
}
}

})